// THE OLD ROUTES THE KYCKCONNECT RESTRUCTURE MOVED (redesign Phase 1). PURE.
//
// Every old path redirects to its new home so bookmarks, Slack alerts and emailed links keep working. The query string is
// ALWAYS carried across (an old `?submission=<id>` still opens that lead). The conference booth page `/lead-bot/live/:botId` is
// deliberately NOT here: it does not move.

export interface LegacyRedirect {
  from: string;
  /** May hold `:param` segments (filled from the old path) and its own query string. */
  to: string;
}

export const LEGACY_REDIRECTS: readonly LegacyRedirect[] = [
  { from: '/lead-bot', to: '/kyckconnect/approvals' },
  { from: '/lead-bot/settings', to: '/kyckconnect/bot-settings' },
  { from: '/lead-bot/report', to: '/kyckconnect/reports' },
  { from: '/lead-relay/log', to: '/kyckconnect/lead-relay/log' },
  { from: '/lead-relay/routes', to: '/kyckconnect/lead-relay/routes' },
  { from: '/lead-relay/routes/:id', to: '/kyckconnect/lead-relay/routes/:id' },
  { from: '/speed-to-lead/leads', to: '/kyckconnect/leads' },
  { from: '/settings/speed-to-lead', to: '/kyckconnect/numbers' },
  { from: '/business-profile/:accountId', to: '/accounts/:accountId?tab=kyckconnect&sub=setup&step=profile' },
];

/** Fill `:param` segments and merge the incoming query string. The target's own keys win over incoming ones. */
export function buildRedirect(to: string, params: Record<string, string | undefined>, incomingSearch: string): string {
  const [rawPath = '', rawQuery = ''] = to.split('?');
  const path = rawPath.replace(/:([A-Za-z]+)/g, (_m, name: string) => encodeURIComponent(params[name] ?? ''));
  const merged = new URLSearchParams(incomingSearch.startsWith('?') ? incomingSearch.slice(1) : incomingSearch);
  for (const [k, v] of new URLSearchParams(rawQuery)) merged.set(k, v);
  const qs = merged.toString();
  return qs ? `${path}?${qs}` : path;
}

function matchPattern(pattern: string, pathname: string): Record<string, string> | null {
  const a = pattern.split('/');
  const b = pathname.replace(/\/+$/, '').split('/');
  if (a.length !== b.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < a.length; i++) {
    const seg = a[i] as string;
    if (seg.startsWith(':')) params[seg.slice(1)] = decodeURIComponent(b[i] as string);
    else if (seg !== b[i]) return null;
  }
  return params;
}

/** Where an old URL goes, or null when it is not a moved route. (The router uses the table directly; this is the testable twin.) */
export function resolveLegacyRedirect(pathname: string, search: string): string | null {
  for (const r of LEGACY_REDIRECTS) {
    const params = matchPattern(r.from, pathname);
    if (params) return buildRedirect(r.to, params, search);
  }
  return null;
}
